(ns hypnos.backoffice.core.catalog
  "Function for the catalog."
  (:require [com.rpl.specter :as spr]
            [medley.core :as mc]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn all-manufacturers
  "Return all manufacturers from the masks."
  [masks]
  (spr/transform [spr/ALL]
                 #(select-keys % [:manufacturer/id :manufacturer/key :manufacturer/name])
                 masks))

(defn lookup-manufacturer-by-id
  "Return manufacturer with passed in id."
  [masks manufacturer-id]
  (let [manufacturer-uuid (if (string? manufacturer-id) (mc/uuid manufacturer-id) manufacturer-id)]
    (spr/select-one [spr/ALL
                     (spr/pred #(= (:manufacturer/id %) manufacturer-uuid))
                     (spr/submap [:manufacturer/id :manufacturer/key :manufacturer/name])]
                    masks)))

(defn all-makes-by-manufacturer-id
  "Return all makes for the manufacturer."
  [masks manufacturer-id]
  (let [manufacturer-uuid (if (string? manufacturer-id) (mc/uuid manufacturer-id) manufacturer-id)]
    (->> masks
         (spr/select [spr/ALL
                      (spr/pred #(= (:manufacturer/id %) manufacturer-uuid))
                      (spr/keypath :make/_manufacturer)
                      spr/ALL])
         (map #(select-keys % [:make/id :make/type :make/category :make/name :make/fit-guide])))))

(defn lookup-make-by-id
  "Return make for the manufacturer by id."
  [masks manufacturer-id make-id]
  (let [manufacturer-uuid (if (string? manufacturer-id) (mc/uuid manufacturer-id) manufacturer-id)
        make-uuid         (if (string? make-id) (mc/uuid make-id) make-id)]
    (spr/select-one [spr/ALL
                     (spr/pred #(= (:manufacturer/id %) manufacturer-uuid))
                     (spr/keypath :make/_manufacturer)
                     spr/ALL
                     (spr/pred #(= (:make/id %) make-uuid))
                     (spr/submap [:make/id :make/type :make/category :make/name :make/fit-guide])]
                    masks)))

(defn all-models-by-manufacturer-id-make-id
  "Return all models for the manufacturer and make."
  [masks manufacturer-id make-id]
  (let [manufacturer-uuid (if (string? manufacturer-id) (mc/uuid manufacturer-id) manufacturer-id)
        make-uuid         (if (string? make-id) (mc/uuid make-id) make-id)]
    (->> masks
         (spr/select [spr/ALL
                      (spr/pred #(= (:manufacturer/id %) manufacturer-uuid))
                      (spr/keypath :make/_manufacturer)
                      spr/ALL
                      (spr/pred #(= (:make/id %) make-uuid))
                      (spr/keypath :model/_make)
                      spr/ALL ])
        (mapv #(select-keys % [:model/id :model/name :model/description :model/gender :model/size :model/sku])))))

(defn lookup-model-by-id
  "Return model for the manufacturer and make by id."
  [masks manufacturer-id make-id model-id]
  (let [manufacturer-uuid (if (string? manufacturer-id) (mc/uuid manufacturer-id) manufacturer-id)
        make-uuid         (if (string? make-id) (mc/uuid make-id) make-id)
        model-uuid        (if (string? model-id) (mc/uuid model-id) model-id)]
    (spr/select-one [spr/ALL
                     (spr/pred #(= (:manufacturer/id %) manufacturer-uuid))
                     (spr/keypath :make/_manufacturer)
                     spr/ALL
                     (spr/pred #(= (:make/id %) make-uuid))
                     (spr/keypath :model/_make)
                     spr/ALL
                     (spr/pred #(= (:model/id %) model-uuid))
                     (spr/submap [:model/id :model/name :model/description :model/gender :model/size :model/sku])]
                    masks)))

(defn lookup-mask-by-model-id
  "Return manufacturer, make, and model id for the (model) id."
  [masks model-id]
  (let [model-uuid (if (string? model-id) (mc/uuid model-id) model-id)
        path       [spr/ALL
                    (spr/collect :manufacturer/id)
                    (spr/keypath :make/_manufacturer)
                    spr/ALL
                    (spr/collect-one :make/id)
                    (spr/keypath :model/_make)
                    spr/ALL
                    (spr/pred #(= (:model/id %) model-uuid))
                    (spr/submap [:model/id])]
        res        (flatten (spr/select path masks))]
    (when-not (empty? res)
      (-> {}
          (assoc :manufacturer/id (first res))
          (assoc :make/id (second res))
          (merge (last res))))))
